export default __webpack_public_path__ + "static/media/serial_connect-24px-grey.a96e19be.svg";